if (window.location.pathname.includes("/login")) {
} else {

(function patch_block_toolboxes() {
	let blocks = frappe.workspace_block && frappe.workspace_block.blocks;
	const TOOLBOX_OVERRIDES = {
		header: { title: "Title", icon: "H2" },
		paragraph: { title: "Rich Text", icon: "\u2261" }, // ≡
		card: { title: "Content Card", icon: "\u25A3" }, // ▣
		chart: { title: "Data Chart", icon: "\u25A5" }, // ▥
		shortcut: { title: "Quick Link", icon: "\u2197" }, // ↗
		spacer: { title: "Spacing", icon: "\u2195" }, // ↕
		onboarding: { title: "Guided Steps", icon: "\u25C7" }, // ◇
		quick_list: { title: "Quick List", icon: "\u2637" }, // ☷
		number_card: { title: "KPI Card", icon: "\u25C9" }, // ◉
		custom_block: { title: "Custom Widget", icon: "\u25C6" }, // ◆
	};

	if (!blocks) {
		setTimeout(patch_block_toolboxes, 300);
		return;
	}

	let missing = [];
	Object.keys(TOOLBOX_OVERRIDES).forEach((key) => {
		if (!blocks[key]) {
			missing.push(key);
			return;
		}
		Object.defineProperty(blocks[key], "toolbox", {
			get() {
				return TOOLBOX_OVERRIDES[key];
			},
			configurable: true,
		});
	});

	if (missing.length) {
		setTimeout(patch_block_toolboxes, 300);
		return;
	}
})();

frappe.router.on("change", () => {
	setTimeout(() => {
		$(".block-list-container .dropdown-title").remove();
	}, 300);
});

// workspace button text change
frappe.router.on("change", () => {
	setTimeout(() => {
		$(".btn-new-workspace .hidden-xs").text(__("New Board"));
		$(".btn-edit-workspace .hidden-xs").text(__("Modify"));
		$(".btn-new-workspace svg").replaceWith(
			`<span class="workspace-btn-icon">⊞</span>`
		);
		$(".btn-edit-workspace svg").replaceWith(
			`<span class="workspace-btn-icon">✎</span>`
		);
		$(".workspace-footer").css({
			position: "absolute",
			top: "15px",
			right: "20px",
			display: "flex",
			gap: "10px",
			zIndex: "1000"
		});
		$(".workspace-footer .btn").css({
			display: "flex",
			alignItems: "center",
			gap: "8px"
		});
		$(".workspace-btn-icon").css({
			fontSize: "16px",
			lineHeight: "1",
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "center",
			width: "16px"
		});
	}, 300);
});
}